import React from 'react';
import { ContractSellerInfo, ContractSellerConfirmation } from '~/scenes';
import { Stack } from '../stackNavigation';

export const ContractSellerNavigation = (
  <Stack.Group>
    <Stack.Screen
      name="MarisaServicos_ContractSellerInfo"
      component={ContractSellerInfo}
    />

    <Stack.Screen
      name="MarisaServicos_ContractSellerConfirmation"
      component={ContractSellerConfirmation}
    />
  </Stack.Group>
);
